export const getSortModel = (sortColumn: string, sortType: 'asc' | 'desc') => {
  return `${sortColumn},${sortType}`;
};
